import {
  faArrowRotateLeft,
  faArrowRotateRight,
} from '@awesome.me/kit-4a6bf60416/icons/classic/regular';
import {
  faReflectHorizontal,
  faReflectVertical,
} from '@awesome.me/kit-4a6bf60416/icons/classic/solid';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';

interface RotationControlsProps {
  onFlip: (direction: 'horizontal' | 'vertical') => void;
  onRotate90: (direction: 'left' | 'right') => void;
}

const ROTATION_BUTTONS: Array<
  | { type: 'flip'; direction: 'horizontal' | 'vertical'; label: string; icon: IconDefinition }
  | { type: 'rotate'; direction: 'left' | 'right'; label: string; icon: IconDefinition }
> = [
  { type: 'flip', direction: 'vertical', label: 'Flip Y', icon: faReflectVertical },
  { type: 'flip', direction: 'horizontal', label: 'Flip X', icon: faReflectHorizontal },
  { type: 'rotate', direction: 'left', label: '-90°', icon: faArrowRotateLeft },
  { type: 'rotate', direction: 'right', label: '90°', icon: faArrowRotateRight },
];

export function RotationControls({ onFlip, onRotate90 }: RotationControlsProps) {
  const handleAction = (btn: (typeof ROTATION_BUTTONS)[number]) => {
    if (btn.type === 'flip') onFlip(btn.direction);
    else onRotate90(btn.direction);
  };

  return (
    <div className="grid grid-cols-2 gap-x-3 gap-y-2">
      {ROTATION_BUTTONS.map((btn) => (
        <Button
          key={`${btn.type}-${btn.direction}`}
          onClick={() => handleAction(btn)}
          variant="outline"
          colorScheme="secondary"
        >
          <Icon icon={btn.icon} className="size-5" />
          {btn.label}
        </Button>
      ))}
    </div>
  );
}
